__turbopack_context__.v({
  "container": "mobile-layout-module-sass-module__uzsTjW__container",
});
